/* Book a visit (sections/greatbuy-book-visit.liquid).
 * Where? -> When? (day, time, who) -> Your details + Confirm booking; one step open at a time. The schedule (locations, show dates, hours, team) comes from
 * snippets/greatbuy-visit-schedule.liquid, generated by scripts/visit-schedule.cjs.
 * Submitting: 1) POST /apps/ltl/visit saves the booking in Shopify (Showroom visits) and blocks double-booking;
 *    and the service emails the chosen rep and the customer (Postmark);
 * 2) the page then posts Shopify's own contact form, which sends sales@greatbuy.com a short copy.
 * If step 1 is unavailable the sales@ copy still goes out, so no request is lost.
 * The date/slot helpers below are an exact copy of scripts/ltl-quote-service/visits/rules.js (checked by
 * scripts/book-visit.test.cjs). */
(function () {
  'use strict';
  var pad = function (n) { return String(n).padStart(2, '0'); };
  var toMin = function (t) { return Number(t.slice(0, 2)) * 60 + Number(t.slice(3, 5)); };
  var toTime = function (m) { return pad(Math.floor(m / 60)) + ':' + pad(m % 60); };
  var addDays = function (date, n) { return new Date(Date.parse(date + 'T12:00:00Z') + n * 86400000).toISOString().slice(0, 10); };
  var weekday = function (date) { return new Date(date + 'T12:00:00Z').getUTCDay(); };
  function partsIn(tz, ms) {
    var p = {};
    new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
    return { date: p.year + '-' + p.month + '-' + p.day, minutes: Number(p.hour) * 60 + Number(p.minute) };
  }
  function zonedToUtc(date, time, tz) {
    var ymd = date.split('-').map(Number), target = Date.UTC(ymd[0], ymd[1] - 1, ymd[2], 0, toMin(time)), guess = target;
    for (var i = 0; i < 3; i++) {
      var p = partsIn(tz, guess), q = p.date.split('-').map(Number);
      guess += target - Date.UTC(q[0], q[1] - 1, q[2], 0, p.minutes);
    }
    return guess;
  }
  function slots(loc, day, now, step) {
    step = step || 30;
    var here = partsIn(loc.tz, now), out = [];
    if (day.date < here.date) return out;
    for (var m = toMin(day.open); m + step <= toMin(day.close); m += step) {
      if (day.date === here.date && m < here.minutes + (loc.leadMinutes || 0)) continue;
      out.push(toTime(m));
    }
    return out;
  }
  function days(loc, now, step) {
    var today = partsIn(loc.tz, now).date, list;
    if (loc.weekly) {
      list = [];
      for (var i = 0; i < (loc.horizonDays || 60); i++) {
        var date = addDays(today, i);
        if (loc.weekly.days.indexOf(weekday(date)) >= 0 && (loc.closed || []).indexOf(date) < 0) list.push({ date: date, open: loc.weekly.open, close: loc.weekly.close, confirmed: true });
      }
    } else list = (loc.dates || []).filter(function (d) { return d.date >= today; });
    return list.filter(function (d) { return slots(loc, d, now, step).length > 0; });
  }
  function slotFree(schedule, t, staff, time) {
    if (!t) return true;
    if (staff && staff !== 'any') return (t.byStaff[staff] || []).indexOf(time) < 0;
    return (t.count[time] || 0) < schedule.staff.length;
  }

  // Display and calendar helpers.
  function timeLabel(t) { var m = toMin(t), h = Math.floor(m / 60); return ((h % 12) || 12) + ':' + pad(m % 60) + ' ' + (h < 12 ? 'AM' : 'PM'); }
  function dayLabel(d, opts) { return new Date(d + 'T12:00:00Z').toLocaleDateString('en-US', Object.assign({ weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' }, opts || {})); }
  function stamp(ms) { return new Date(ms).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); }
  function where(v, loc) { return loc.virtual ? (v.meeting_link || 'Zoom (link emailed before the call)') : loc.address; }
  function calendarText(v, loc, staffName) {
    return 'Great Buy visit · ' + loc.name + '\n' + (loc.virtual ? 'Join on Zoom: ' + where(v, loc) : loc.venue + '\n' + loc.address) + '\nMeeting with: ' + staffName + '\nReference: ' + v.reference + '\nQuestions: 213-290-2018 · sales@greatbuy.com';
  }
  // "1:00 PM your time" when the visitor's clock differs from the location's (mostly for Zoom calls).
  function localTime(date, time, loc, viewerTz) {
    var tz = viewerTz || (Intl.DateTimeFormat().resolvedOptions().timeZone);
    if (!tz || tz === loc.tz) return '';
    var p = partsIn(tz, zonedToUtc(date, time, loc.tz));
    if (p.minutes === partsIn(loc.tz, zonedToUtc(date, time, loc.tz)).minutes) return '';
    return timeLabel(toTime(p.minutes)) + ' your time' + (p.date !== date ? ' (' + dayLabel(p.date) + ')' : '');
  }
  function googleUrl(v, loc, staffName, minutes) {
    var start = zonedToUtc(v.date, v.time, loc.tz);
    return 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent('Great Buy visit · ' + loc.name) +
      '&dates=' + stamp(start) + '/' + stamp(start + (minutes || 30) * 60000) + '&location=' + encodeURIComponent(where(v, loc)) + '&details=' + encodeURIComponent(calendarText(v, loc, staffName));
  }
  function ics(v, loc, staffName, minutes) {
    var start = zonedToUtc(v.date, v.time, loc.tz), esc = function (s) { return String(s).replace(/[\\;,]/g, '\\$&').replace(/\n/g, '\\n'); };
    return ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Great Buy//Book a visit//EN', 'METHOD:PUBLISH', 'BEGIN:VEVENT',
      'UID:' + v.reference + '@greatbuy.com', 'DTSTAMP:' + stamp(Date.now()), 'DTSTART:' + stamp(start), 'DTEND:' + stamp(start + (minutes || 30) * 60000),
      'SUMMARY:' + esc('Great Buy visit · ' + loc.name), 'LOCATION:' + esc(where(v, loc)), 'DESCRIPTION:' + esc(calendarText(v, loc, staffName)),
      'END:VEVENT', 'END:VCALENDAR'].join('\r\n') + '\r\n';
  }

  var api = { partsIn: partsIn, zonedToUtc: zonedToUtc, slots: slots, days: days, slotFree: slotFree, timeLabel: timeLabel, dayLabel: dayLabel, googleUrl: googleUrl, ics: ics, localTime: localTime };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  window.GBVisit = api; // shared with assets/greatbuy-locations.js (Locations hub and location pages)
  if (typeof document === 'undefined') return;

  var root = document.querySelector('[data-gb-visit]');
  var dataEl = document.getElementById('gb-visit-schedule');
  if (!root || !dataEl) return;
  var schedule = JSON.parse(dataEl.textContent);
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var STORE_KEY = 'gb-visit-booked';
  var state = { location: null, staff: 'any', date: null, time: null, taken: null, days: [] };
  var takenCache = {};
  var locById = function (id) { return schedule.locations.filter(function (l) { return l.id === id; })[0]; };
  // The team comes from Shopify (Showroom visits -> Team) via the App Proxy; the built-in list is the fallback.
  // schedule.staff always holds who can be booked at the chosen location (it also sets "first available" capacity).
  var allStaff = schedule.staff.slice();
  var teamFor = function (locId) {
    var only = (locById(locId) || {}).staffOnly; // e.g. CHAMPS Austin: only Jennifer
    return allStaff.filter(function (m) { return (!locId || !m.locations || !m.locations.length || m.locations.indexOf(locId) >= 0) && (!only || only.indexOf(m.id) >= 0); });
  };
  var staffName = function (id) { var s = allStaff.filter(function (x) { return x.id === id; })[0]; return s ? s.name : 'First available'; };
  var firstName = function (id) { return id === 'any' ? 'our team' : staffName(id).split(' ')[0]; };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };
  var narrow = function () { return window.matchMedia && matchMedia('(max-width: 749px)').matches; };
  var whenText = function (date, time, loc) { var mine = localTime(date, time, loc); return dayLabel(date, { weekday: 'short', month: 'short' }) + ' · ' + timeLabel(time) + ' ' + loc.tzLabel + (mine ? ' (' + mine + ')' : ''); };

  // ----- steps: one open at a time; finished steps fold to a one-line answer with "Change" -----
  var panel = function (n) { return $('[data-step-panel="' + n + '"]'); };
  var finished = function (n) { return n === 1 ? Boolean(state.location) : n === 2 ? Boolean(state.location && state.date && state.time) : false; };
  function openStep(n, scroll) {
    [1, 2, 3].forEach(function (k) {
      var p = panel(k), st = k === n ? 'open' : finished(k) ? 'done' : 'locked';
      p.setAttribute('data-state', st);
      var change = $('[data-change]', p); if (change) change.hidden = st !== 'done';
    });
    if (scroll && root.getAttribute('data-ready')) {
      var top = panel(n).getBoundingClientRect().top + window.pageYOffset - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--gb-header-h'), 10) || 0) - 12;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }
  function picked() {
    var loc = state.location;
    $('[data-picked]', panel(1)).innerHTML = loc ? esc(loc.short || loc.name) + '<small>' + esc(loc.virtual ? "We'll send you the Zoom link" : loc.address) + '</small>' : '';
    $('[data-picked]', panel(2)).innerHTML = loc && state.date && state.time ? esc(whenText(state.date, state.time, loc)) + '<small>with ' + esc(staffName(state.staff)) + '</small>' : '';
  }

  // ----- step 1: where (compact rows built from the schedule) -----
  var BOOTH = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 9h18l-2-5H5z"/><path d="M5 9v11M19 9v11M3 20h18M9 20v-6h6v6"/></svg>';
  var VIDEO = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2.5" y="6" width="13" height="12" rx="2.5"/><path d="M15.5 10.5 21.5 7v10l-6-3.5z"/></svg>';
  function buildLocations() {
    var base = root.getAttribute('data-asset-base') || '';
    var photos = {};
    try { photos = JSON.parse(root.getAttribute('data-photos') || '{}'); } catch (e) { photos = {}; }
    $('[data-locs]').innerHTML = schedule.locations.map(function (l) {
      var p = (photos.locations || {})[l.id] || {};
      var thumb = l.virtual ? '<span class="gb-visit__thumb gb-visit__thumb--zoom">' + VIDEO + '</span>'
        : p.photo ? '<span class="gb-visit__thumb"><img src="' + esc(p.photo) + '" alt="" loading="lazy" width="60" height="60"></span>'
        : l.logo ? '<span class="gb-visit__thumb gb-visit__thumb--logo' + (l.logoOnDark ? ' gb-visit__thumb--dark' : '') + '"><img src="' + esc(base + l.logo) + '" alt="" loading="lazy" width="60" height="60"></span>'
        : '<span class="gb-visit__thumb gb-visit__thumb--event">' + BOOTH + '</span>'; // traveling show booth (CHAMPS)
      return '<label class="gb-visit__loc" data-loc="' + esc(l.id) + '"><input type="radio" name="gb-visit-loc" value="' + esc(l.id) + '">' + thumb +
        '<span class="gb-visit__loc-body"><strong>' + esc(l.short || l.name) + '</strong><small>' + esc(l.virtual ? 'Video call from anywhere' : l.address.split(',').slice(-2).join(',').trim()) + '</small><span class="gb-visit__loc-next" data-loc-next></span></span>' +
        '<span class="gb-visit__radio" aria-hidden="true"></span></label>';
    }).join('');
    $$('[data-loc] input').forEach(function (input) { input.addEventListener('change', function () { chooseLocation(input.value); openStep(2, true); }); });
  }
  function nextLine(loc) {
    if (loc.weekly) return 'Mon–Fri · ' + timeLabel(loc.weekly.open).replace(':00', '') + '–' + timeLabel(loc.weekly.close).replace(':00', '') + ' ' + loc.tzLabel;
    var list = days(loc, Date.now(), schedule.slotMinutes);
    if (!list.length) return 'Next dates coming soon';
    var runs = [], cur = null;
    list.forEach(function (d) {
      if (cur && addDays(cur.end, 1) === d.date) cur.end = d.date; else { cur = { start: d.date, end: d.date }; runs.push(cur); }
    });
    var fmt = function (r) { return r.start === r.end ? dayLabel(r.start, { weekday: undefined }) : dayLabel(r.start, { weekday: undefined }) + '–' + (r.start.slice(0, 7) === r.end.slice(0, 7) ? Number(r.end.slice(8)) : dayLabel(r.end, { weekday: undefined })); };
    return 'Next: ' + fmt(runs[0]) + (runs[1] ? ' · then ' + fmt(runs[1]) : '');
  }
  function renderLocations() {
    $$('[data-loc]').forEach(function (card) {
      var loc = locById(card.getAttribute('data-loc'));
      var open = days(loc, Date.now(), schedule.slotMinutes).length > 0;
      $('[data-loc-next]', card).textContent = nextLine(loc);
      card.toggleAttribute('data-closed', !open);
      $('input', card).disabled = !open;
    });
  }
  function chooseLocation(id, keepDate) {
    var loc = locById(id);
    if (!loc) return;
    state.location = loc;
    state.days = days(loc, Date.now(), schedule.slotMinutes);
    if (!keepDate || !state.days.some(function (d) { return d.date === state.date; })) { state.date = state.days.length ? state.days[0].date : null; state.time = null; }
    var input = $('[data-loc="' + id + '"] input'); if (input) input.checked = true;
    buildTeam();
    renderDates();
    summary();
  }

  // ----- step 2: when (day, time) and who -----
  function buildTeam() {
    schedule.staff = teamFor(state.location && state.location.id);
    if (state.staff !== 'any' && !schedule.staff.some(function (s) { return s.id === state.staff; })) state.staff = 'any';
    var sel = $('[data-staff-select]');
    var solo = schedule.staff.length === 1 && state.location && state.location.staffOnly; // CHAMPS: you meet Jennifer
    if (solo) state.staff = schedule.staff[0].id;
    sel.innerHTML = (solo ? '' : '<option value="any">First available</option>') + schedule.staff.map(function (s) { return '<option value="' + esc(s.id) + '">' + esc(s.name) + '</option>'; }).join('');
    sel.value = state.staff;
  }
  function loadTeam() {
    return fetch('/apps/ltl/visit/team', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; })
      .then(function (d) { if (d && Array.isArray(d.staff) && d.staff.length) { allStaff = d.staff; buildTeam(); if (state.location) renderTimes(); summary(); } });
  }
  function chooseStaff(id) {
    state.staff = id;
    $('[data-staff-select]').value = id;
    renderTimes();
    summary();
  }
  // who is already booked
  function loadTaken(loc, date) {
    var key = loc.id + '|' + date;
    if (takenCache[key]) return Promise.resolve(takenCache[key]);
    return fetch('/apps/ltl/visit/availability?location=' + encodeURIComponent(loc.id) + '&date=' + date, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (d) { var t = d && d.taken ? d.taken : null; takenCache[key] = t; return t; })
      .catch(function () { return null; });
  }
  function renderDates() {
    var strip = $('[data-dates]');
    strip.innerHTML = '';
    state.days.forEach(function (d) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'gb-visit__date'; b.setAttribute('aria-pressed', String(d.date === state.date)); b.setAttribute('data-date', d.date);
      b.setAttribute('aria-label', dayLabel(d.date, { weekday: 'long', month: 'long' }));
      b.innerHTML = '<small>' + esc(dayLabel(d.date, { month: undefined, day: undefined })) + '</small><strong>' + Number(d.date.slice(8)) + '</strong><small>' + esc(dayLabel(d.date, { weekday: undefined, day: undefined })) + '</small>';
      b.addEventListener('click', function () { state.date = d.date; state.time = null; renderDates(); summary(); });
      strip.appendChild(b);
    });
    var sel = strip.querySelector('[aria-pressed="true"]');
    if (sel) strip.scrollLeft = Math.max(0, sel.offsetLeft - strip.offsetLeft - 8);
    $('[data-no-dates]').hidden = state.days.length > 0;
    renderTimes();
  }
  function renderTimes() {
    var grid = $('[data-times]'), note = $('[data-hours-note]');
    grid.innerHTML = '';
    var loc = state.location, day = loc && state.days.filter(function (d) { return d.date === state.date; })[0];
    note.hidden = !(day && day.confirmed === false);
    var tzNote = $('[data-tz-note]');
    var sample = day && localTime(day.date, day.open, loc);
    tzNote.hidden = !sample; tzNote.textContent = sample ? 'Times are ' + loc.tzLabel + ' time. ' + timeLabel(day.open) + ' ' + loc.tzLabel + ' is ' + sample + '.' : '';
    if (!day) return;
    var list = slots(loc, day, Date.now(), schedule.slotMinutes);
    var paint = function (t) {
      state.taken = t;
      grid.innerHTML = '';
      var free = 0;
      list.forEach(function (time) {
        var ok = slotFree(schedule, t, state.staff, time);
        if (ok) free++;
        if (!ok && state.time === time) state.time = null;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'gb-visit__time'; b.disabled = !ok; b.setAttribute('aria-pressed', String(state.time === time));
        b.textContent = timeLabel(time);
        if (!ok) b.setAttribute('aria-label', timeLabel(time) + ' booked');
        b.addEventListener('click', function () { state.time = time; summary(); openStep(3, true); });
        grid.appendChild(b);
      });
      $('[data-full]').hidden = free > 0;
      $('[data-full]').textContent = state.staff === 'any' ? 'This day is fully booked. Please pick another day.' : firstName(state.staff) + ' is fully booked this day. Pick another day, or choose "First available".';
      summary();
    };
    paint(takenCache[loc.id + '|' + day.date] || null);
    grid.setAttribute('aria-busy', 'true');
    loadTaken(loc, day.date).then(function (t) { grid.removeAttribute('aria-busy'); if (state.location === loc && state.date === day.date) paint(t); });
  }

  // ----- recap above the button + validation -----
  function summary() {
    var loc = state.location;
    picked();
    var recap = $('[data-recap]');
    recap.innerHTML = loc && state.date && state.time ? esc((loc.short || loc.name) + ' · ' + whenText(state.date, state.time, loc)) + '<small>with ' + esc(staffName(state.staff)) + (loc.virtual ? " · we'll send the Zoom link" : ' · ' + esc(loc.address)) + '</small>' : '';
    $('[data-next]').hidden = !(loc && state.date && state.time); // back in step 2 with a time still picked: one tap to continue
    if (panel(3).getAttribute('data-state') === 'open' && !(loc && state.date && state.time)) openStep(loc ? 2 : 1);
  }
  function fieldError(name, msg) {
    var input = $('[name="' + name + '"]');
    var holder = input && input.closest('.gb-visit__field');
    if (holder) { holder.toggleAttribute('data-invalid', Boolean(msg)); var e = $('.gb-visit__err', holder); if (e) e.textContent = msg || ''; }
    return !msg;
  }
  function collect() {
    var f = $('[data-details]');
    var get = function (n) { var el = f.elements[n]; return el ? String(el.value || '').trim() : ''; };
    var v = {
      location: state.location && state.location.id, date: state.date, time: state.time, staff: state.staff,
      name: get('name'), company: get('company'), email: get('email'), phone: get('phone'), visitors: Number(get('visitors')) || 1,
      buyer_type: get('buyer_type'), interests: $$('[name="interests"]:checked', f).map(function (x) { return x.value; }), notes: get('notes'), website: get('website'),
      source: location.pathname,
    };
    var ok = true;
    ok = fieldError('name', v.name ? '' : 'Add your name') && ok;
    ok = fieldError('company', v.company ? '' : 'Add your company') && ok;
    ok = fieldError('email', /^[^\s@<>()]+@[^\s@<>()]+\.[^\s@<>()]{2,}$/.test(v.email) ? '' : 'Add a valid email') && ok;
    ok = fieldError('phone', (v.phone.match(/\d/g) || []).length >= 7 ? '' : 'Add a phone number') && ok;
    return ok ? v : null;
  }
  function alertBox(msg) { var a = $('[data-alert]'); a.textContent = msg || ''; a.hidden = !msg; if (msg) a.scrollIntoView({ block: 'center', behavior: 'smooth' }); }

  // ----- submit: save in Shopify (the service emails the rep and the customer), then send sales@ a copy -----
  function submit(e) {
    e.preventDefault();
    alertBox('');
    if (!state.location || !state.date || !state.time) { alertBox('Choose a location, day and time first.'); openStep(state.location ? 2 : 1, true); return; }
    var v = collect();
    if (!v) { var bad = $('[data-invalid] input'); if (bad) bad.focus(); return; }
    var btn = $('[data-submit]');
    btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Booking…';
    var controller = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, 12000);
    fetch('/apps/ltl/visit', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(v), signal: controller ? controller.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .catch(function () { return {}; })
      .then(function (res) {
        clearTimeout(timer);
        if (res && res.error && [400, 409, 429].indexOf(res.code) >= 0) {
          btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = 'Confirm booking';
          if (res.code === 409) { delete takenCache[v.location + '|' + v.date]; state.time = null; renderTimes(); openStep(2, true); }
          alertBox(res.error);
          return;
        }
        v.reference = (res && res.reference) || 'GB-' + Math.random().toString(36).slice(2, 8).toUpperCase();
        if (res && res.meeting_link) v.meeting_link = res.meeting_link;
        v.emailed = Boolean(res && res.emailed && res.emailed.customer);
        sendEmail(v, Boolean(res && res.saved));
      });
  }
  // sales@ copy through Shopify's contact form: the short version; the rep's own email has everything.
  function sendEmail(v, saved) {
    var loc = locById(v.location), form = $('[data-contact]');
    var when = dayLabel(v.date, { weekday: 'long', month: 'long', year: 'numeric' }) + ' · ' + timeLabel(v.time) + ' ' + loc.tzLabel + ' time';
    var set = function (name, value) { var el = form.querySelector('[name="contact[' + name + ']"]'); if (el) el.value = value; };
    set('name', v.name); set('email', v.email); set('phone', v.phone);
    set('Visit', (loc.short || loc.name) + ' · ' + when);
    set('Meeting with', staffName(v.staff));
    set('Company', v.company);
    set('Reference', v.reference + (saved ? ' (Shopify: Apps → GreatBuy LTL → Showroom visits)' : ''));
    var extra = [v.visitors > 1 ? 'Visitors: ' + v.visitors : '', v.buyer_type ? 'Buyer type: ' + v.buyer_type : '', v.interests.length ? 'Shopping for: ' + v.interests.join(', ') : '',
      loc.virtual ? 'Zoom: ' + (v.meeting_link || 'send the customer a link') : '', v.notes ? 'Notes: ' + v.notes : ''].filter(Boolean);
    set('body', (loc.virtual ? 'Zoom call' : 'Showroom visit') + ' booked online. ' + (v.staff === 'any' ? 'First available: please assign someone.' : staffName(v.staff) + ' has been emailed.') + (extra.length ? '\n\n' + extra.join('\n') : ''));
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ v: v, at: Date.now() })); } catch (err) { /* confirmation falls back to the generic message */ }
    // requestSubmit fires the submit event, so Shopify's spam check (hCaptcha) adds its token. calling submit() directly skips it and
    // Shopify rejects the message ("Missing CAPTCHA token"), found when testing 2026-10-01.
    if (form.requestSubmit) form.requestSubmit(); else form.querySelector('[type="submit"]').click();
  }

  // ----- confirmation (after Shopify's contact form returns) -----
  function confirmation() {
    var raw = null;
    try { raw = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch (e) { raw = null; }
    var done = $('[data-done]');
    root.setAttribute('data-booked', '');
    done.hidden = false;
    if (raw && raw.v && Date.now() - raw.at < 3600000) {
      var v = raw.v, loc = locById(v.location), who = staffName(v.staff);
      $('[data-done-title]', done).textContent = "You're booked, " + v.name.split(' ')[0] + '!';
      $('[data-done-lede]', done).textContent = v.emailed ? 'We sent the details and a calendar invite to ' + v.email + '.' : "We've sent it to our team. We'll confirm by email or phone.";
      $('[data-done-when]', done).textContent = dayLabel(v.date, { weekday: 'long', month: 'long', year: 'numeric' }) + ' · ' + timeLabel(v.time) + ' ' + loc.tzLabel + ' time';
      $('[data-done-where]', done).textContent = loc.virtual ? 'Zoom video call' : (loc.short || loc.name);
      $('[data-done-address]', done).textContent = loc.virtual ? (v.meeting_link ? 'Your Zoom link is below and in your calendar invite.' : "We'll email your Zoom link before the call.") : loc.address;
      var mineDone = localTime(v.date, v.time, loc);
      if (mineDone) $('[data-done-when]', done).textContent += ' (' + mineDone + ')';
      var join = $('[data-zoom]', done);
      if (join) { join.hidden = !(loc.virtual && v.meeting_link); if (v.meeting_link) join.href = v.meeting_link; }
      $('[data-map]', done).hidden = Boolean(loc.virtual);
      $('[data-done-who]', done).textContent = v.staff === 'any' ? 'A member of our team' : who;
      $('[data-done-ref]', done).textContent = v.reference;
      $('[data-gcal]', done).href = googleUrl(v, loc, who);
      $('[data-map]', done).href = loc.map;
      var blob = new Blob([ics(v, loc, who)], { type: 'text/calendar' });
      var a = $('[data-ics]', done); a.href = URL.createObjectURL(blob); a.download = 'great-buy-visit-' + v.date + '.ics';
      $('[data-done-details]', done).hidden = false;
    }
    done.scrollIntoView({ block: 'start' });
    try { sessionStorage.removeItem(STORE_KEY); } catch (e) { /* ignore */ }
  }

  // ----- wire up -----
  buildLocations();
  buildTeam();
  $('[data-staff-select]').addEventListener('change', function (e) { chooseStaff(e.target.value); });
  $('[data-next]').addEventListener('click', function () { openStep(3, true); });
  $$('[data-change]').forEach(function (b) { b.addEventListener('click', function () { openStep(Number(b.closest('[data-step-panel]').getAttribute('data-step-panel')), true); }); });
  var teamReady = loadTeam();
  $('[data-details]').addEventListener('submit', submit);
  $('[data-again]').addEventListener('click', function () { var url = new URL(location.href); url.search = ''; url.hash = ''; location.href = url.toString(); });
  renderLocations();
  if (root.querySelector('[data-posted-ok]')) { confirmation(); return; }
  var postError = root.querySelector('[data-posted-error]');
  if (postError) alertBox('Your booking could not be sent: ' + postError.textContent.trim() + ' Please try again or call 213-290-2018.');
  // Deep links (?location=&date=&time=&with=) open at the first unanswered step.
  var q = new URLSearchParams(location.search);
  var startLoc = locById(q.get('location')) || null;
  var wanted = q.get('with');
  if (wanted && allStaff.some(function (s) { return s.id === wanted; })) chooseStaff(wanted);
  teamReady.then(function () { if (wanted && state.staff !== wanted && schedule.staff.some(function (s) { return s.id === wanted; })) chooseStaff(wanted); });
  if (startLoc) {
    if (q.get('date')) state.date = q.get('date');
    chooseLocation(startLoc.id, Boolean(q.get('date')));
    if (q.get('time') && slots(startLoc, state.days.filter(function (d) { return d.date === state.date; })[0] || { date: '0000-00-00', open: '00:00', close: '00:00' }, Date.now(), schedule.slotMinutes).indexOf(q.get('time')) >= 0) { state.time = q.get('time'); renderTimes(); }
  }
  summary();
  openStep(!startLoc ? 1 : state.time ? 3 : 2);
  root.setAttribute('data-ready', '');
  if (startLoc && narrow()) openStep(state.time ? 3 : 2, true); // phones: jump past the hero to the open step
})();
